import app from '../app';
import Component from '../../common/Component';
import Button from '../../common/components/Button';
import ItemList from '../../common/utils/ItemList';
const LOCAL_STORAGE_KEY = 'welcomeHidden';

/**
 * The `WelcomeHero` component displays a hero that welcomes the user to the
 * forum.
 */
export default class WelcomeHero extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view(vnode) {
    if (this.isHidden()) return null;
    const slideUp = () => {
      this.$().slideUp(this.hide.bind(this));
    };
    return m("header", {
      className: "Hero WelcomeHero"
    }, m("div", {
      className: "container"
    }, m(Button, {
      icon: "fas fa-times",
      onclick: slideUp,
      className: "Hero-close Button Button--icon Button--link",
      "aria-label": app.translator.trans('core.forum.welcome_hero.hide')
    }), m("div", {
      className: "containerNarrow"
    }, this.welcomeItems().toArray())));
  }

  /**
   * Hide the welcome hero.
   */
  hide() {
    localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
  }

  /**
   * Determines whether the welcome hero should be hidden.
   *
   * @returns if the welcome hero is hidden.
   */
  isHidden() {
    if (!app.forum.attribute('welcomeTitle')?.trim()) return true;
    if (localStorage.getItem(LOCAL_STORAGE_KEY)) return true;
    return false;
  }
  welcomeItems() {
    const items = new ItemList();
    items.add('hero-title', m("h1", {
      className: "Hero-title"
    }, app.forum.attribute('welcomeTitle')), 20);
    items.add('hero-subtitle', m("div", {
      className: "Hero-subtitle"
    }, m.trust(app.forum.attribute('welcomeMessage'))), 10);
    return items;
  }
}
flarum.reg.add('core', 'forum/components/WelcomeHero', WelcomeHero);